const teamList = [
  {
    id: 1,
    name: 'Kurt Allmeroth',
    title: 'Software Engineer (Web)',
    image: 'team_kurt.jpg',
  },
  {
    id: 2,
    name: 'Richard Bradshaw',
    title: 'Software Engineer (Mobile/Web)',
    image: 'team_richard.jpg',
  },
  {
    id: 3,
    name: 'Dylan Bromby',
    title: 'Founder',
    image: 'team_dylan2.jpg',
  },
  {
    id: 4,
    name: 'Cale Crawford',
    title: 'Software Engineer/Architect',
    image: 'cale2.jpg',
  },
  {
    id: 5,
    name: 'Danny Gilbertson',
    title: 'Quality Engineer (Mobile/Web)',
    image: 'team_danny3.jpg',
  },
  {
    id: 6,
    name: 'Nik Lilland',
    title: 'Software Engineer (Mobile/Web)',
    image: 'team_nik2.jpg',
  },
  {
    id: 7,
    name: 'Garrett Milovich',
    title: 'Software Engineer (Mobile)',
    image: 'team_garrett2.jpg',
  },
  {
    id: 8,
    name: 'Ben Rausch',
    title: 'Software Engineer (Mobile)',
    image: 'team_ben.jpg',
  },
  {
    id: 9,
    name: 'Jordon Saardchit',
    title: 'Software Architect',
    image: 'team_jordon.jpg',
  },
]

export default {
  getTeam(cb) {
    setTimeout(() => cb(teamList), 0)
  },
}
